import { Box, Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
  button: {
    fontWeight: 500,
    lineHeight: '19px',
    fontSize: '14px',
    padding: '8px 43px',
    borderRadius: '500px',
    textTransform: 'capitalize',
    minWidth: '170px',
  },
  buttonWhite: {
    fontWeight: 500,
    lineHeight: '19px',
    fontSize: '14px',
    padding: '8px 43px',
    borderRadius: '500px',
    background: 'white',
    textTransform: 'capitalize',
    minWidth: '170px',
  },
  title: {
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '37px',
    textAlign: 'center',
  },
  content: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '21px',
    textAlign: 'center',
  },
});

export const SuccessIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.8628 34.2594L17.0871 27.4838C16.6833 27.0799 16.1757 26.8734 15.5643 26.864C14.9529 26.8546 14.436 27.0612 14.0134 27.4838C13.5909 27.9063 13.3796 28.4186 13.3796 29.0206C13.3796 29.6226 13.5909 30.1349 14.0134 30.5574L22.0174 38.5614C22.5447 39.0886 23.1598 39.3522 23.8628 39.3522C24.5658 39.3522 25.1809 39.0886 25.7081 38.5614L41.9348 22.3347C42.3387 21.9308 42.5453 21.4232 42.5546 20.8119C42.564 20.2005 42.3574 19.6835 41.9348 19.261C41.5123 18.8385 41 18.6272 40.398 18.6272C39.796 18.6272 39.2838 18.8385 38.8613 19.261L23.8628 34.2594ZM28.0071 55.708C24.1748 55.708 20.5726 54.9808 17.2006 53.5264C13.8284 52.0719 10.8952 50.0981 8.40082 47.6048C5.90639 45.1115 3.93164 42.1795 2.47656 38.8089C1.02148 35.4384 0.293945 31.837 0.293945 28.0047C0.293945 24.1723 1.02117 20.5702 2.47561 17.1981C3.93006 13.826 5.90391 10.8928 8.39717 8.39838C10.8905 5.90395 13.8224 3.9292 17.193 2.47412C20.5636 1.01905 24.165 0.291504 27.9973 0.291504C31.8296 0.291504 35.4318 1.01873 38.8039 2.47317C42.176 3.92762 45.1092 5.90147 47.6036 8.39473C50.098 10.888 52.0728 13.82 53.5279 17.1906C54.9829 20.5611 55.7105 24.1626 55.7105 27.9949C55.7105 31.8272 54.9832 35.4294 53.5288 38.8014C52.0744 42.1735 50.1005 45.1068 47.6072 47.6012C45.1139 50.0956 42.182 52.0703 38.8114 53.5254C35.4408 54.9805 31.8394 55.708 28.0071 55.708ZM28.0022 51.3331C34.5161 51.3331 40.0335 49.0727 44.5543 44.5519C49.0751 40.031 51.3355 34.5137 51.3355 27.9998C51.3355 21.4859 49.0751 15.9685 44.5543 11.4477C40.0335 6.92685 34.5161 4.66643 28.0022 4.66643C21.4883 4.66643 15.971 6.92685 11.4501 11.4477C6.92929 15.9685 4.66887 21.4859 4.66887 27.9998C4.66887 34.5137 6.92929 40.031 11.4501 44.5519C15.971 49.0727 21.4883 51.3331 28.0022 51.3331Z"
        fill="#0FA459"
      />
    </svg>
  );
};

export const Success = ({ handleClick, mode }) => {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      margin="150px auto 0 auto"
      maxWidth="500px"
      flexDirection="column"
      gap="8px"
    >
      <Box margin="0 auto">
        <SuccessIcon />
      </Box>
      <Typography className={classes.title}>
        ¡Objetivo {mode == 'edit' ? 'editado' : 'creado'} con éxito!
      </Typography>
      <Typography className={classes.content}>
        Notificaremos al líder que tiene un nuevo objetivo para su equipo. Podés
        ver y editar los objetivos cuando lo necesites.
      </Typography>
      <Box display="flex" gap="16px" margin="40px auto 0 auto">
        <Button
          variant="outlined"
          component={Link}
          to="/goals"
          className={classes.buttonWhite}
        >
          Ver Objetivos
        </Button>
        <Button
          variant="contained"
          onClick={() => handleClick()}
          className={classes.button}
        >
          Nuevo objetivo
        </Button>
      </Box>
    </Box>
  );
};
